import React, { useState, useEffect } from 'react'
import { Form } from 'react-bootstrap';
import {
    updateSchemeBankAccountApproval, get_departments, AddBankAccount, getBankAccountById, update_account_balance_interest
} from '../../../helper/Api';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Col, Container, Row } from 'react-bootstrap'
import AccountPreview from '../Model/AccountPreview';
import CustomBreadcrumbs from '../../Tools/Breadcumbs';
import { 
    FormControl, 
    InputLabel, 
    Select, 
    MenuItem,
    TextField,
    FormHelperText,
} from "@mui/material";
import Spinner from '../../Tools/spinner';
const AddChildAccount = ({ isHolding = false }) => {
    const [loading, setLoading] = useState(false);
    const { id,viewId} = useParams();
    const isReadOnly = viewId;
    const { authData } = useSelector((state) => state.authData);
    const [department, setDepartment] = useState([]);
    const [showPreview, setShowPreview] = useState(false);
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        "id": "",
        "account_name": "",
        "bank_name": "",
        "branch_name": "",
        "ifsc_code": "",
        "ifsc_code_bank": "",
        "account_type": "",
        "account_no": "",
        "account_balance": "",
        "balance_date": "",
        "interest": "",
        "quarter": "",
        "interest_date": "",
        "email":"",
        "mobile":"",
        "l2_approval": "",
        "l3_approval": "",
        "l1_remark": "",
        "l2_remark": "",
        "l3_remark": "",
        "department_id": "",
        'added_by': authData.user.id,
        "approval_type": "joint",
        "is_holding": isHolding ? 1 : 0
    })

    const navigate = useNavigate();
    const getFieldError = (name, value) => {
        if (name === 'account_no') {
            if (!value) return 'Account number is required.';
            if (!/^\d+$/.test(value)) return 'Account number must contain digits only.';
            if (value.length > 14) return 'Account number must be at most 30 digits.';
            return '';
        }

        if (name === 'ifsc_code') {
            if (!value) return 'IFSC code is required.';
            if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(value)) {
                return 'Invalid IFSC code (e.g. SBIN0001234).';
            }
            return '';
        }

        if (name === 'ifsc_code_bank') {
            if (!value) return 'IFSC code (Bank) is required.';
            if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(value)) {
                return 'Invalid IFSC code (Bank) (e.g. SBIN0001234).';
            }
            return '';
        }

        if (name === 'quarter') {
            if (!value) return 'Please select a quarter.';
            return '';
        }

        if (name === 'email') {
            if (!value) return 'Email is required.';
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                return 'Please enter a valid email address.';
            }
            return '';
        }

        if (name === 'mobile') {
            if (!value) return 'Mobile number is required.';
            if (!/^[6-9]\d{9}$/.test(value)) {
                return 'Enter a valid 10-digit Indian mobile number.';
            }
            return '';
        }

        return '';
    };

    const validate = () => {
        const fieldsToValidate = ['account_no', 'ifsc_code', 'ifsc_code_bank', 'email', 'mobile'];
        if (!isHolding) {
            fieldsToValidate.push('quarter');
        }
        const newErrors = {};

        fieldsToValidate.forEach((field) => {
            const error = getFieldError(field, formData[field]);
            if (error) {
                newErrors[field] = error;
            }
        });

        setErrors(newErrors);
        return newErrors;
    };

    const previewHandler = (e) => {
        e.preventDefault();
        const newErrors = validate();
        if (Object.keys(newErrors).length) {
            const firstKey = Object.keys(newErrors)[0];
            toast.error(newErrors[firstKey] || 'Please fix the validation errors before proceeding.', {
                position: toast.POSITION.TOP_CENTER
            });
            return;
        }
        setShowPreview(true);
    };
    useEffect(() => {
        fetchDepartments();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const newErrors = validate();
        if (Object.keys(newErrors).length) {
            setShowPreview(false);
            const firstKey = Object.keys(newErrors)[0];
            toast.error(newErrors[firstKey] || 'Please fix the validation errors before submitting.', {
                position: toast.POSITION.TOP_CENTER
            });
            return;
        }
        setLoading(true);
        try {
            let response;
            if (id) {
                response = await update_account_balance_interest(formData, id);
            } else {
                response = await AddBankAccount(formData);
            }
            if (response.data.status) {
                toast.success(response.data.message, {
                    position: toast.POSITION.TOP_CENTER
                });
                navigate(isHolding ? '/holdingAccountList' : '/childAccountList');
            } else {
                toast.error(response.data.message, {
                    position: toast.POSITION.TOP_CENTER
                });
            }
        } catch (error) {
            toast.error(error.message, {
                position: toast.POSITION.TOP_CENTER
            });
        } finally {
            setLoading(false);
        }

    }
    const handleChange = (e) => {
        const { name, value } = e.target;
        let finalValue = value;

        if (name === 'account_no') {
            if (!/^\d*$/.test(value)) return;
            finalValue = value.slice(0, 14);
        }

        if (name === 'mobile') {
            if (!/^\d*$/.test(value)) return;
            const limited = value.slice(0, 10);
            if (limited.length > 0 && !/^[6-9]/.test(limited)) return;
            finalValue = limited;
        }

        if (name === 'ifsc_code') {
            const normalized = value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 11);
            if (!/^[A-Z]{0,4}(0[A-Z0-9]{0,6})?$/.test(normalized)) return;
            finalValue = normalized;
        }

        if (name === 'ifsc_code_bank') {
            const normalized = value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 11);
            if (!/^[A-Z]{0,4}(0[A-Z0-9]{0,6})?$/.test(normalized)) return;
            finalValue = normalized;
        }

        if (name === 'email') {
            finalValue = value.replace(/\s/g, '');
        }

        setFormData((prev) => ({ ...prev, [name]: finalValue }));

        if (['account_no', 'ifsc_code', 'ifsc_code_bank', 'quarter', 'email', 'mobile'].includes(name)) {
            const error = getFieldError(name, finalValue);
            setErrors((prev) => {
                const next = { ...prev };
                if (error) {
                    next[name] = error;
                } else {
                    delete next[name];
                }
                return next;
            });
            return;
        }

        if (errors[name]) {
            setErrors((prev) => {
                const next = { ...prev };
                delete next[name];
                return next;
            });
        }
    }
    const onApprove = async (status) => {
        formData.l2_approval = authData.user.user_type == 'l2' ? status : formData.l2_approval;
        formData.l3_approval = authData.user.user_type == 'l3' ? status : formData.l3_approval;
        let approvalData = {
            l2_approval: formData.l2_approval,
            l3_approval: formData.l3_approval,
            l2_remark: formData.l2_remark,
            l3_remark: formData.l3_remark
        }
        await updateSchemeBankAccountApproval(approvalData, formData.id);
    }
    const fetchDepartments = async () => {
        try {
            setLoading(true);
            const departments = await get_departments({ parent_department_id: authData.user.department_details.id });
            if (departments.data.status) {
                if(authData.user.department_details.department_level != 'T1') {
                    setDepartment(departments.data.result.filter(dept => dept.id != authData.user.department_details.id));
                }else {
                    setDepartment(departments.data.result);
                }
                
            }
        } catch (error) {
            toast.error(error?.message || 'Failed to fetch departments', {
                position: toast.POSITION.TOP_CENTER
            });
        } finally {
            setLoading(false);
        }
    }

    const fetchBankAccountById = async () => {
        try {
            setLoading(true);
            const response = await getBankAccountById(id);
            if (response.data.status) {
                setFormData(response.data.result);
            } else {
                toast.error(response.data.message, {
                    position: toast.POSITION.TOP_CENTER
                });
            }
        } catch (error) {
            toast.error(error.message, {
                position: toast.POSITION.TOP_CENTER
            });
        } finally {
            setLoading(false);
        }

    }

    useEffect(() => {
        if (id) {
            fetchBankAccountById();
        }
    }, [id]);

    return (
        <div>
            {loading && <div > <Spinner/> </div>}
            <AccountPreview showPreview={showPreview} setShowPreview={setShowPreview} formData={formData} handleSubmit={handleSubmit} department={department} isHolding={isHolding}></AccountPreview>
            <div className="p-3">
                <div className="row" style={{ padding: "10px 16px" }}>
                    <div className="col-md-6">
                        <h4 style={{ color: "#28326f", margin:0}}>{isHolding ? "Add Holding Bank Account" : "Add Bank Account"}</h4>
                        <CustomBreadcrumbs linksArray={[{
                            href: isHolding ? '/holdingAccountList' : '/childAccountList',
                            label: isHolding ? 'Holding Bank Accounts' : 'Bank Accounts'
                        }]} title={isHolding ? "Add Holding Bank Account" : "Add Bank Account"}/>
                    </div>
                    <div className="col-md-6">
                        <div className="d-flex gap-2" style={{ width: "auto", float: "right" }}>
                            <button type="button" className="submit_button" onClick={previewHandler}>
                                {id ? 'Update Account' : isHolding ? 'Add Holding Account' : 'Add Account'}
                            </button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <Form>
                    <div className="col-md-12">
                        <div className="card p-3 mt-3">
                            <div className="row">
                                {/* <Form> */}
                                <Container>
                                    <Row>
                                        <Col md={4} className='mb-3'>
                                            <FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label">Department *</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    label="Department *"
                                                    id="department_id"
                                                    name='department_id'
                                                    required
                                                    value={formData.department_id || ""}
                                                    onChange={handleChange} 
                                                    readOnly={isReadOnly}
                                                >
                                                    {department.map((dept) => (
                                                        <MenuItem value={dept.id} key={dept.id}>
                                                            {dept.name} - {dept.code}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Col>
                                        <Col md={4} className='mb-3'>
                                            <FormControl fullWidth>
                                                <TextField 
                                                id="account_name"
                                                label="Account Name" 
                                                variant="outlined" 
                                                type="text"
                                                name="account_name"
                                                value={formData.account_name || ""} 
                                                onChange={handleChange}
                                                required
                                                readOnly={isReadOnly}
                                                />
                                            </FormControl>
                                        </Col>
                                        <Col md={4} className='mb-3'>
                                            <FormControl fullWidth>
                                                <TextField 
                                                id="bank_name"
                                                label="Bank Name" 
                                                variant="outlined" 
                                                type="text"
                                                name="bank_name"
                                                value={formData.bank_name || ""} 
                                                onChange={handleChange}
                                                required
                                                readOnly={isReadOnly}
                                                />
                                            </FormControl>
                                        </Col>
                                        <Col md={4} className='mb-3'>
                                            <FormControl fullWidth>
                                                <TextField 
                                                id="branch_name"
                                                label="Branch Name" 
                                                variant="outlined" 
                                                type="text"
                                                name="branch_name"
                                                value={formData.branch_name || ""} 
                                                onChange={handleChange}
                                                required
                                                readOnly={isReadOnly}
                                                />
                                            </FormControl>
                                        </Col>
                                        <Col md={4} className='mb-3'>
                                            <FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label">Account Type *</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    label="Account Type *"
                                                    id="account_type"
                                                    name='account_type'
                                                    required
                                                    value={formData.account_type || ""}
                                                    onChange={handleChange} 
                                                    readOnly={isReadOnly}
                                                >
                                                    <MenuItem value="saving" >Saving Account</MenuItem>
                                                    <MenuItem value="current" >Current Account</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Col>
                                        <Col md={4} className='mb-3'>
                                            <FormControl fullWidth>
                                                <TextField 
                                                id="account_no"
                                                label="Account No" 
                                                variant="outlined" 
                                                type="text"
                                                name="account_no"
                                                value={formData.account_no || ""} 
                                                onChange={handleChange}
                                                required
                                                inputProps={{ maxLength: 14 }}
                                                error={!!errors.account_no}
                                                helperText={errors.account_no || ''}
                                                readOnly={isReadOnly}
                                                />
                                            </FormControl>
                                        </Col>
                                        <Col md={4} className='mb-3'>
                                            <FormControl fullWidth>
                                                <TextField 
                                                id="account_balance"
                                                label="Account Balance" 
                                                variant="outlined" 
                                                type="number"
                                                name="account_balance"
                                                value={formData.account_balance || ""} 
                                                onChange={handleChange}
                                                required
                                                readOnly={isReadOnly}
                                                />
                                            </FormControl>
                                        </Col>
                                        <Col md={4} className='mb-3'>
                                            <FormControl fullWidth>
                                                <TextField 
                                                    id="ifsc_code"
                                                    label="IFSC Code (Mapped On IFMS)" 
                                                    variant="outlined" 
                                                    type="text"
                                                    name="ifsc_code"
                                                    value={formData.ifsc_code || ""} 
                                                    onChange={handleChange}
                                                    required
                                                    inputProps={{ maxLength: 11 }}
                                                    error={!!errors.ifsc_code}
                                                    helperText={errors.ifsc_code || ''}
                                                    readOnly={isReadOnly}
                                                    />
                                            </FormControl>
                                        </Col>
                                        <Col md={4} className='mb-3'>
                                            <FormControl fullWidth>
                                                <TextField 
                                                id="ifsc_code_bank"
                                                label="IFSC Code - (Bank)" 
                                                variant="outlined" 
                                                type="text"
                                                name="ifsc_code_bank"
                                                value={formData.ifsc_code_bank || ""} 
                                                onChange={handleChange}
                                                required
                                                inputProps={{ maxLength: 11 }}
                                                error={!!errors.ifsc_code_bank}
                                                helperText={errors.ifsc_code_bank || ''}
                                                readOnly={isReadOnly}
                                                />
                                            </FormControl>
                                        </Col>
                                        <Col md={4} className='mb-3'>
                                            <FormControl fullWidth>
                                                <TextField 
                                                    id="balance_date"
                                                    label="Closing Balance Date" 
                                                    variant="outlined" 
                                                    type="date"
                                                    name="balance_date"
                                                    value={formData.balance_date || ""} 
                                                    onChange={handleChange}
                                                    InputLabelProps={{ shrink: true }}
                                                    readOnly={isReadOnly}
                                                    required
                                                />
                                            </FormControl>
                                        </Col>
                                        {!isHolding && ( <>
                                        <Col md={4} className='mb-3'>
                                            <FormControl fullWidth>
                                                <TextField 
                                                    id="interest"
                                                    label="Interest" 
                                                    variant="outlined" 
                                                    type="number"
                                                    name="interest"
                                                    value={formData.interest || ""} 
                                                    onChange={handleChange}
                                                    readOnly={isReadOnly}
                                                    required
                                                />
                                            </FormControl>
                                        </Col>
                                        <Col md={4} className='mb-3'>
                                            <FormControl fullWidth>
                                                <TextField 
                                                    id="interest_date"
                                                    label="Interest Date" 
                                                    variant="outlined" 
                                                    type="date"
                                                    name="interest_date"
                                                    value={formData.interest_date || ""} 
                                                    onChange={handleChange}
                                                    InputLabelProps={{ shrink: true }}
                                                    readOnly={isReadOnly}
                                                    required
                                                />
                                            </FormControl>
                                        </Col>
                                        <Col md={4} className='mb-3'>
                                            <FormControl fullWidth error={!!errors.quarter}>
                                                    <InputLabel id="quarter-select-label">Quarter</InputLabel>
                                                    <Select
                                                        labelId="quarter-select-label"
                                                        id="quarter"
                                                        name="quarter"
                                                        label="Quarter"
                                                        value={formData.quarter || ""}
                                                        onChange={handleChange}
                                                        required
                                                        readOnly={isReadOnly}
                                                    >
                                                        <MenuItem value={1}>1</MenuItem>
                                                        <MenuItem value={2}>2</MenuItem>
                                                        <MenuItem value={3}>3</MenuItem>
                                                        <MenuItem value={4}>4</MenuItem>
                                                    </Select>
                                                    {errors.quarter && <FormHelperText>{errors.quarter}</FormHelperText>}
                                            </FormControl>
                                        </Col>
                                        </>)}

                                        <Col md={4} className='mb-3'>
                                            <FormControl fullWidth>
                                                <TextField 
                                                    id="email"
                                                    label="Branch Email ID" 
                                                    variant="outlined" 
                                                    type="email"
                                                    name="email"
                                                    value={formData.email || ""} 
                                                    onChange={handleChange}
                                                    readOnly={isReadOnly}
                                                    required
                                                    error={!!errors.email}
                                                    helperText={errors.email || ''}
                                                />
                                            </FormControl>
                                        </Col>
                                        <Col md={4} className='mb-3'>
                                            <FormControl fullWidth>
                                                <TextField 
                                                    id="mobile"
                                                    label="Branch Mobile No." 
                                                    variant="outlined" 
                                                    type="text"
                                                    name="mobile"
                                                    value={formData.mobile || ""} 
                                                    onChange={handleChange}
                                                    readOnly={isReadOnly}
                                                    required
                                                    inputProps={{ maxLength: 10 }}
                                                    error={!!errors.mobile}
                                                    helperText={errors.mobile || ''}
                                                />
                                            </FormControl>
                                        </Col>
                                        <Col md={4} className='mb-3'>
                                            <FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label">Approval Type *</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    label="Approval Type *"
                                                    id="approval_type"
                                                    name='approval_type'
                                                    required
                                                    value={formData.approval_type || ""}
                                                    onChange={handleChange} 
                                                    readOnly={isReadOnly}
                                                >
                                                    <MenuItem value="joint" >Joint Approval</MenuItem>
                                                    <MenuItem value="single" >Single Approval</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Col>
                                        
                                    </Row>
                                    {
                                        authData.user.user_type == 'l1' ?
                                            <>
                                                <label>L1 Remark</label>
                                                <textarea className='form-control' onChange={handleChange} name="l1_remark" readOnly={isReadOnly}></textarea>
                                            </>
                                            : ''
                                    }
                                    <br />
                                    {
                                        authData.user.user_type == 'l2' && formData.l2_approval == null ?
                                            <>
                                                <label>L2 Remark</label>
                                                <textarea className='form-control' onChange={handleChange} name="l2_remark" readOnly={isReadOnly}></textarea>
                                                <button type="button" className="btn btn-danger w-30 mt-2" onClick={() => onApprove(0)}>Reject</button>
                                                <button type="button" className="btn btn-primary w-30 mt-2" style={{ marginLeft: '10px' }} onClick={() => onApprove(1)}>Approve</button>
                                            </>
                                            : ''
                                    }
                                    {
                                        authData.user.user_type == 'l3' && formData.l3_approval == null ?
                                            <>
                                                <label>L2 Remark</label>
                                                <textarea className='form-control' onChange={handleChange} name="l3_remark" readOnly={isReadOnly}></textarea>
                                                <button type="button" className="btn btn-danger w-30 mt-2" onClick={() => onApprove(0)}>Reject</button>
                                                <button type="button" className="btn btn-primary w-30 mt-2" style={{ marginLeft: '10px' }} onClick={() => onApprove(1)}>Approve</button>
                                            </>
                                            : ''
                                    }
                                </Container>
                                {/* </Form> */}
                            </div>
                        </div>
                    </div>
                    </Form>
                </div>
            </div>
        </div>
    )
};
export default AddChildAccount;